import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var PlaceholderIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("g", {
                        fillRule: "nonzero",
                        children: _jsx("path", {
                            d: "M5.797 3.018a.994.994 0 01.484 1.925l-.113.028C5.49 5.1 5.13 5.46 4.965 6.2a.994.994 0 11-1.94-.434c.335-1.502 1.301-2.469 2.772-2.748zM20.96 5.797a.994.994 0 01-1.926.484l-.028-.113c-.13-.679-.489-1.038-1.229-1.203a.994.994 0 01.434-1.94c1.502.335 2.468 1.301 2.748 2.772zM18.18 20.989a.994.994 0 01-.484-1.925l.113-.029c.678-.129 1.038-.488 1.203-1.228a.994.994 0 111.94.434c-.335 1.502-1.301 2.468-2.772 2.748zM3.018 18.18a.994.994 0 011.925-.484l.028.113c.13.678.489 1.038 1.229 1.203a.994.994 0 01-.434 1.94c-1.502-.335-2.469-1.301-2.748-2.772zM14.871 3c.624 0 1.129.445 1.129.994 0 .51-.436.93-.997.988l-.132.006H13.63c-.624 0-1.129-.445-1.129-.994 0-.51.436-.93.997-.987L13.63 3h1.242zM14.871 18.977c.624 0 1.129.445 1.129.994 0 .51-.436.93-.997.988l-.132.006H13.63c-.624 0-1.129-.445-1.129-.994 0-.51.436-.93.997-.987l.132-.007h1.242zM5 14.871C5 15.495 4.555 16 4.006 16c-.51 0-.93-.436-.988-.997l-.006-.132V13.63c0-.624.445-1.129.994-1.129.51 0 .93.436.987.997L5 13.63v1.242zM21 14.871c0 .624-.445 1.129-.994 1.129-.51 0-.93-.436-.988-.997l-.006-.132V13.63c0-.624.445-1.129.994-1.129.51 0 .93.436.987.997l.007.132v1.242zM10.371 3c.624 0 1.129.448 1.129 1 0 .513-.436.936-.997.993L10.37 5H9.13C8.505 5 8 4.552 8 4c0-.513.436-.936.997-.993L9.13 3h1.242zM10.371 18.977c.624 0 1.129.448 1.129 1 0 .513-.436.935-.997.993l-.132.007H9.13c-.624 0-1.129-.448-1.129-1 0-.513.436-.936.997-.993l.132-.007h1.242zM5 10.371c0 .624-.448 1.129-1 1.129-.513 0-.936-.436-.993-.997L3 10.37V9.13C3 8.505 3.448 8 4 8c.513 0 .936.436.993.997L5 9.13v1.242zM21 10.371c0 .624-.448 1.129-1 1.129-.513 0-.936-.436-.993-.997L19 10.37V9.13C19 8.505 19.448 8 20 8c.513 0 .936.436.993.997L21 9.13v1.242z"
                        })
                    })
                })
            })
        ]
    });
};
PlaceholderIcon.isCarinaIcon = true;
export default PlaceholderIcon;
